import React, { useEffect, useRef, useState } from "react";
import { Button, Checkbox, Form, Input, Modal, Select, Spin, Tag, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";
import MessageTemplate from "../../mesage-template/MessageTemplate";
import svg7 from "../../../assets/svg/svg7.svg";
import svg43 from "../../../assets/svg/svg43.svg";
import ScheduleModal from "./modal/ScheduleModal";
import { fetchDistinctSenderNames } from "../../../features/filter/filterSlice";
import { sendWhatsAppGroup } from "../../../features/whatsapp/whatsappSlice";
import { extractErrorMessage } from "../../whatsapp/whatsappUtils";
import WhatsAppSenderSelect from "../../../components/WhatsAppSenderSelect";

const { TextArea } = Input;
const CHANNEL_OPTIONS = [
  { label: "SMS", value: "SMS" },
  { label: "WhatsApp", value: "WHATSAPP" },
];

const SmsGroupModal = ({
  isModalOpen,
  setIsModalOpen,
  rowId,
  rowIdTableGroup,
}) => {
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { user } = useSelector((state) => state.auth);
  const { saving } = useSelector((state) => state.save);
  const { saving: whatsappSaving } = useSelector((state) => state.whatsapp);
  const { folderObj } = useSelector((state) => state.folder);
  const { senderNamesData } = useSelector((state) => state.filterSms);
  const [channels, setChannels] = useState(["SMS"]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const smsSelected = channels.includes("SMS");
  const whatsappSelected = channels.includes("WHATSAPP");
  const smsOnly = smsSelected && !whatsappSelected;
  const isSubmitting = saving || whatsappSaving;
  const submitLabel = smsSelected && whatsappSelected
    ? "Send SMS + WhatsApp"
    : whatsappSelected
      ? "Send WhatsApp"
      : "Send";

  function closeModal() {
    toast.dismiss();
  }

 

  const [data, setdata] = useState({});
  const [inputValue, setInputValue] = useState(
    rowId?.length > 0 ? rowId?.[0]?.tmpMessage : ""
  );

  const [isModalSchedule, setIsModalSchedule] = useState(false);
  const showModalConfirmation = async () => {
    if (!inputValue) {
      toast.error("Please enter message");
      return;
    }
    setIsModalSchedule(true);
  };

  const [formData, setFormData] = useState();
  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    if (!smsSelected && !whatsappSelected) {
      toast.error("Please select at least one channel");
      return;
    }
    if (!inputValue) {
      toast.error("Please add message");
      return;
    }

    if (smsSelected && !formData?.senderId) {
      toast.error("Please select sender name");
      return;
    }

    let smsSuccess = !smsSelected;
    let whatsappSuccess = !whatsappSelected;
    let smsError = "";
    let whatsappError = "";
    let smsMessage = "";
    let whatsappMessage = "";

    if (smsSelected) {
      const res = await dispatch(
        save({
          url: `api/v2/sms/group/${folderObj?.groupId}`,
          grpMessage: inputValue,
          senderId: formData?.senderId,
        })
      );
      smsSuccess = Boolean(res?.payload?.success);
      smsMessage = res?.payload?.messages?.message || "SMS sent successfully";
      smsError = res?.payload?.messages?.message || "SMS send failed";
    }

    if (whatsappSelected) {
      const result = await dispatch(
        sendWhatsAppGroup({
          groupId: folderObj?.groupId,
          message: inputValue,
          senderRegistrationId: data?.senderRegistrationId || formData?.senderRegistrationId || undefined,
        })
      );
      whatsappSuccess = sendWhatsAppGroup.fulfilled.match(result);
      whatsappMessage = result?.payload?.messages?.message || "WhatsApp group messages queued successfully";
      whatsappError = extractErrorMessage(result?.payload);
    }

    if (smsSuccess && whatsappSuccess) {
      const successMessage = smsSelected && whatsappSelected
        ? "SMS sent and WhatsApp queued successfully"
        : smsSelected
          ? smsMessage
          : whatsappMessage;
      toast.success(successMessage);
      form.resetFields();
      setInputValue("");
      setFormData(undefined);
      setChannels(["SMS"]);
      setIsModalOpen(false);
      navigate(whatsappSelected && !smsSelected ? "/whatsapp-queue" : "/sent-sms");
      return;
    }

    if (smsSelected && smsSuccess) {
      toast.success(smsMessage);
    } else if (smsSelected) {
      toast.error(smsError);
    }

    if (whatsappSelected && whatsappSuccess) {
      toast.success(whatsappMessage);
    } else if (whatsappSelected) {
      toast.error(whatsappError);
    }

    if (smsSelected && smsSuccess && whatsappSelected && !whatsappSuccess) {
      setChannels(["WHATSAPP"]);
      return;
    }

    if (whatsappSelected && whatsappSuccess && smsSelected && !smsSuccess) {
      setChannels(["SMS"]);
    }
  };

  function fetchDistinctSenderNamesData() {
    dispatch(fetchDistinctSenderNames());
  }

  useEffect(() => {
    setInputValue(rowId?.length > 0 ? rowId?.[0]?.tmpMessage : "");
  }, [rowId]);

  useEffect(() => {
    fetchDistinctSenderNamesData();
  }, []);

  return (
    <>
      <Modal
        className=""
        title="Message"
        open={isModalOpen}
        onOk={onFinish}
        onCancel={handleCancel}
        width={900}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className="px-[15px]"
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item label="Send via">
            <Checkbox.Group
              options={CHANNEL_OPTIONS}
              value={channels}
              onChange={(values) => setChannels(values)}
            />
          </Form.Item>

          {rowIdTableGroup && rowIdTableGroup?.length > 0 && (
            <div className="text-dmSans text-[16px] mb-10 flex flex-col">
              Selected Groups :
              {rowIdTableGroup &&
                rowIdTableGroup?.map((item) => (
                  <span className=" ">
                    <Tag className="bg-green rounded-full px-3 py-1 text-[16px] font-dmSans text-white">
                      {item?.groupName}
                    </Tag>
                  </span>
                ))}
            </div>
          )}

          {smsSelected && (
            <Form.Item
            name="senderId"
            className=""
            label={
              <span>
                Select sender name <span className="text-[#FF0000]">*</span>
              </span>
            }
            rules={[
              {
                required: true,
                message: "Please select sender name",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              onChange={(value) => {
                handleSelectChange(value, "senderId");
              }}
              options={
                senderNamesData?.length > 0 &&
                senderNamesData?.map((item) => ({
                  value: item,
                  label: item,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchDistinctSenderNamesData();
              }}
            />
            </Form.Item>
          )}

          <WhatsAppSenderSelect
            visible={whatsappSelected}
            onChange={(value) => {
              handleSelectChange(value, "senderRegistrationId");
            }}
          />

          <MessageTemplate
            inputValue={inputValue}
            setInputValue={setInputValue}
          />

          <div className="flex justify-between mt-[48px] ">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center mb-[58px] gap-x-5">
              <div className="w-[150px] ">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-[#388E3C] !border !border-[#388E3C]"
                >
                  Cancel
                </button>
              </div>

              <div className="flex">
                <div className="w-[150px]">
                  <button
                    key="submit"
                    type="submit"
                    className={`cstm-btn ${smsOnly ? "!rounded-tr-[0px] !rounded-br-[0px]" : ""}`}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? <Spin /> : submitLabel}
                  </button>
                </div>
                {smsOnly && (
                  <div className="w-[65px]">
                    <Button
                      onClick={showModalConfirmation}
                      className="cstm-btn   !bg-[#739675] !rounded-tl-[0px] !rounded-bl-[0px]  !h-[2.6rem] "
                    >
                      {saving ? (
                        <Spin />
                      ) : (
                        <Tooltip title="Schedule send">
                          <img className="" src={svg43} alt="svg43" />
                        </Tooltip>
                      )}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Form>
      </Modal>

      <ScheduleModal
        isModalOpen={isModalSchedule}
        setIsModalOpen={setIsModalSchedule}
        title={`Schedule Send`}
        inputValue={inputValue}
        setInputValue={setInputValue}
        setIsModalOpenPrev={setIsModalOpen}
        senderId =  {formData?.senderId}
      />
    </>
  );
};
export default SmsGroupModal;
